export default {
  fr: {
    MainTitle : 'Forage',
    Admin : 'Admin',
    Upload : {
      Title : "Téléversement des rapports journaliers",
      Template : "Modèle de téléversement",
      Templates : {
        AEMTemplate : "Modèle AEM",
        Coreplan : "Coreplan"
      },
      Reset : "Réinitialiser",
      BrowseFiles : "Parcourir les fichiers",
      AddMoreFiles : "Ajouter des fichiers",
      Upload : "Téléverser",
      Filename : "Nom du fichier",
      Remove : "Retirer",
      FilesSelected : "{count} fichier(s) sélectionné(s)",
      BadFileExtension : "Seuls les fichiers .xlsx et .xlsm sont autorisés.",
      ValidationResults : "Résultats de validation",
      ValidationResultsDescription : "{total} fichier(s) traité(s) — {passed} réussi(s), {failed} échoué(s).",
      StructureStatus : "Structure",
      ContentStatus : "Contenu",
      Valid : "Valide",
      Invalid : "Invalide",
      StructureValidations : "Validations de structure",
      ContentValidations : "Validations de contenu",
      ValidationName : "Validation",
      ClickToShowDetails : "Cliquer pour afficher les détails",
      Ingest : "Importer",
      ImportationSuccessful : "Le(s) fichier(s) ont été importés avec succès.",
      NoFilesToIngest : "Aucun fichier valide à importer.",
      IngestError : "Une erreur est survenue lors de l'importation du/des fichier(s).",
      ValidationResultsCompleteSuccess : "Tous les fichiers ont passé la validation et sont prêts à être importés.",
      ValidationResultsPartialSuccess : "Certains fichiers ont échoué à la validation. Seuls les fichiers valides seront importés."
    },
    DailyReports : {
      Title : "Rapports journaliers",
      Vendor : "Fournisseur",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce rapport journalier?",
      ShowDeleted : "Afficher les rapport supprimés",
      DailyReportDeleted : "Le rapport journalier a été correctement supprimé",
      NoDailyReportSelected : "Aucun rapport journalier de sélectionné",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces rapports journalier?",
      ConfirmDeleteMultipleImported: "Parmis les rapports sélectionnés, certains ou tous ont déjà été importés. Cette action annulera l'importation. Souhaitez-vous réellement supprimer ces rapports journalier importés?",
      ConfirmRestore : "Souhaitez-vous réellement restaurer ce rapport?",
      RestoreCompleted : "Le rapport a été correctement restauré",
      ConfirmImport: "Souhaitez-vous réellement importer les rapports sélectionnées?",
      ImportCompleted: "Les rapports ont été correctement importées",
      ConfirmCancelImport: "Souhaitez-vous réellement annuler l'importation de ce rapport?",
      CancelImportCompleted: "L'importation du rapport a été correctement annulée",
      ConfirmCancelImportBatch: "Souhaitez-vous réellement annuler l'importation des rapports sélectionnées?",
      CancelImportCompletedBatch: "L'importation des rapports a été correctement annulée",
      ConfirmSaveWithInvalidFrom :  "Souhaitez-vous réellement sauvegarder ce rapport malgré les valeurs invalides?",
      ConfirmImportWithInvalidFrom :  "Souhaitez-vous réellement importer ce rapport malgré les valeurs invalides?",
      ShiftRequiredBeforeImport : "Chaque entrée doit avoir un quart avant que le rapport puisse être approuvé.",
      ShiftRequiredMessage : "Le quart est obligatoire",
      ImportAndNextReport: "Importer et passer au rapport suivant",
      ImportSelected: "Importer les rapports sélectionnés",
      NoReportSelected: "Aucun rapport sélectionné",
      Add : "Ajouter un rapport",
      Edit : "Édition d'un rapport",
      View : "Visualiser un rapport",
      CancelImport : "Annuler l'importation",
      Restore : "Annuler la suppression",
      EditNotes: "Éditer les notes",
      EditTitle : "{reportDate} - Foreuse {drillCode}",
      InvalidProject : "Propriété invalide",
      InvalidContract : "Contrat invalide",
      InvalidDrill : "Foreuse invalide",
      Tab1 : "Informations générales",
      Tab2 : "Entrées de temps",
      Tab3 : "Entrées de forage",
      Tab4 : "Stabilisations",
      Tab5 : "Tests de Déviation",
      InvalidDataInTab : "Données invalides trouvées dans l'onglet",
      Dashboard : "Tableau de bord",
      Importation: {
        ResultTitle: "Résultats d'importation"
      },
      UnapprovedHours: "Heures non approuvées",
      ApprovedHours: "Heures approuvées",
      TotalHours: "Total des heures",
      SummaryByEmployee: "Sommaire par employé"
    },
    JobEntries : {
      Employee : "Employé",
      Title : "Titre",
      Shift : "Quart",
      Hours : "Heures",
      TaskPlaceholder: "Nom de la tâche",
      TaskName : "Tâche",
      EmployeePlaceholder : "Nom de l'employee",
      EditTask : "Modifier une tâche",
      EditTimeEntry : "Modifier une entrée de temps",
      AddTimeEntry : "Ajouter une entrée de temps",
      AddEmployee : "Ajouter un employé",
      AddTask : "Ajouter une tâche",
      IsBillable : "Facturable?",
      IsNonBillableShort : "(NF)",
      ShowAllTasks : "Voir toutes les tâches",
      StatsTitle :"Entrées de temps",
      OtherTask: "Autre tâche",
      Note: "Note",
      DuplicateEntry: "Cet entrée existe déjà",
      InitialValue: "Valeur initiale :"
    },
    DrillEntries : {
      Dip : "Inclinaison de forage",
      Azimut : "Azimut",
      CoreSize : "Taille de la carotte",
      From : "De",
      To : "À",
      MetersDrilled : "Mètres forés",
      IsEndOfHole : "Fin de trou",
      IsDevico : "Directionnel",
      IsOriented : "Orienté",
      IsAutomated: "Automatisé",
      IsCemented : "Cimenté",
      ToLowerThanFromMessage : "Mètres forés invalide",
      FromDiffThanPreviousEntry : "Le valeur est différente que son entrée différente ({latestTo})",
      HoleEnded : "Ce trou a déjà été déclaré comme fini",
      AddDrillingEntry : "Ajouter une entrée de forage",
      EditDrillingEntry : "Modifier une entrée de forage",
      AddNewHole : "Ajouter un trou",
      AddHoleInProject : "Ajouter ce trou à la propriété",
      StatsTitle : "Entrées de forage",
      NotesTitle : "Notes",
      Note: "Note",
      LastValue: "Valeur préc.:",
      Author: "Auteur"
    },
    Stabilisations : {
      CoreBarrel: "Tube carottier",
      Shell: "Manchon aléseur (longueur)",
      Length: "Longueur",
      Quantity: "Quantité",
      MustBeGreaterThanPreviousTo: "La valeur doit être plus grande que la valeur 'À' de la dernière stabilisation ({latestTo}).",
      FromMustBeLessThanTo: "La valeur 'De' doit être plus petite que la valeur 'À'.",
      AddEntry: "Ajouter une entrée de stabilisation"
    },
    Drills : {
      Title : "Foreuses",
      Name : "Foreuse",
      Code : "Code",
      IsActive : "Actif?",
      IsAutomated : "Automatisée?",
      DrillingCapacity : "Capacité de forage",
      MovedBy : "Déplacement",
      Dimensions : "Dimensions",
      Length : "Longueur",
      Width : "Largeur",
      Height : "Hauteur",
      AddNew: "Ajouter une foreuse",
      Edit : "Éditer une foreuse",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cete foreuse?",
      DrillDeleted : "La foreuse a été correctement supprimée"
    },
    Holes : {
      Title : "Trous de forage",
      Name : "Trou",
      Code : "Code",
      AddNew: "Ajouter un trou de forage",
      Edit : "Éditer un trou de forage",
      Easting : "Easting",
      Northing : "Northing",
      CollarAzimuth : "Collar Azimuth",
      CollarDip : "Collar Dip",
      LiftRate : "Lift Rate",
      DriftRate : "Drift Rate",
      Distance : "Distance",
      Extension : "Extension",
      Target : "Cible",
      TargetZone : "Zone",
      TargetDepth : "Profondeur prévue",
      TargetPriority : "Priorité",
      StartMeters : "Profondeur initiale (m)",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce trou de forage?",
      HoleDeleted : "Le trou de forage a été correctement supprimé",
      LatestTo: "Dernier À",
      LatestToDate: "Dernière date À",
      IsEndOfHole: "Fin de trou",
      ShowAllHoles: "Afficher tous les trous",
      NoSelection: "Aucun trou sélectionné",
      SelectHole: "Sélectionner un trou",
      EndOfHoleSet: "Fin de trou a été définie avec succès",
      EndOfHoleNotSet: "Fin de trou n'a pas été définie"
    },
    HoleStatus : {
      'Name' : "Statut du trou",
      '0' : "Planifié",
      '1' : "En cours",
      '2' : "Terminé"
    },
    DrillHoleTypes : {
      'Name' : "Type de trous",
      '1' : "Conversion",
      '2' : "Extension",
      '3' : "Exploration",
      '4' : "Geotechnique",
      '5' : "Delineation",
      '6' : "Définition",
      '7' : "Trou de service",
      '99' : "Inconnu"
    },
    ExpenseTypes: {
      "Name": "Type de dépense",
      "1": "Croissance capitalisée",
      "2": "Soutien capitalisé",
      "3": "Dépense",
      "4": "Exploitation"
    },
    DrillingTypes : {
      'Name' : "Drilling type",
      '1' : "Diamond Drill",
      '2' : "Directional",
      '3' : "Down the Hole Hammer",
      '4' : "Rotary Air Blast Drilling",
      '5' : "Reverse Circulation",
      '6' : "Sludge drilling",
      '7' : "Soil",
      '8' : "Sonic Drilling",
      '9' : "Blast Hole Type",
      '99' : "Inconnu"
    },
    CoordinateSystemTypes : {
      'Name' : "Système de coordonnés",
      '1' : "UTMNAD83 Zone 17N",
      '2' : "Upper Canada Geo Grid",
      '3' : "Upper Beaver Geo Grid",
      '4' : "UTMNAD83 Zone 14",
      '5' : "UTMNAD83 Zone 15",
      '99' : "Inconnu"
    },
    MovedBy : {
      'Name' : 'Déplacement',
      '0' : "Remorque",
      '1' : "Autopropulsée"
    },
    RigTransportTypes : {
      'Name' : "Type de transport de foreuse",
      '1' : "Remorquée",
      '2' : "Héliportée"
    },
    Contracts : {
      Title : "Contrats",
      Name : "Contrat",
      Code : "Code",
      Location : "Location",
      Property : "Propriété",
      State : "État",
      Vendor : "Fournisseur",
      Company : "Compagnie",
      AddNew: "Ajouter un contrat",
      Edit : "Éditer un contrat",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce contrat?",
      ContractDeleted : "Le contrat a été correctement supprimé",
      CodeNotUnique : "Le code doit être unique."
    },

    Projects : {
      Title : "Propriétés",
      SingleTitle : "Propriété",
      Edit : "Éditer une propriété",
      Name : "Nom",
      Code : "Code",
      CodeUnique : "Ce code existe déjà et ne peut pas être ajouté.",
      District : "District",
      Country : "Pays",
      HolePrefix : "Préfix des trous",
      BusinessUnitCode : "Code unité d'affaire",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette propriété?",
      ProjectDeleted : "La propriété a été correctement supprimé",
      Tab1 : "Informations générales",
      Tab2 : "Zones",
      Tab3 : "Trous"
    },
    Zones : {
      Title : "Zones",
      SingleTitle : "Zones",
      Name : "Nom",
      Edit : "Modifier une zone",
      ZonePlaceholder : "Nom de la zone",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette zone?"
    },
    Companies : {
      Title : "Compagnies",
      Name : "Compagnie",
      ShortName : "Nom court",
      Address : "Adresse",
      City : "Ville",
      Province : "Province",
      Contact : "Contact",
      Phone : "Téléphone",
      Email : "Courriel",
      AddNew: "Ajouter une compagnie",
      Edit : "Éditer une compagnie",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette compagnie?",
      CompanyDeleted : "La compagnie a été correctement supprimé"
    },
    Employees : {
      Title : "Employés",
      Name : "Employé",
      FirstName : "Prénom",
      LastName : "Nom",
      ReferenceName : "Nom de référence",
      IsActive: "Actif",
      EmployeeNumber: "Numéro d'employé",
      Company : "Compagnie",
      AddNew: "Ajouter un employé",
      Edit : "Éditer un employé",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cet employe?",
      DeletedConfirmation : "L'employé a été correctement supprimé"
    },
    Reports : {
      Title : "Rapports",
      Dashboard : "Tableau de bord (ancien)",
      Optimized : "Tableau de bord",
      Analytics : "Analytique du forage"
    },
    Unmapped : {
      ConfirmDelete: "Êtes-vous sûr de vouloir supprimer ce rapport journalier?",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces rapports journalier?",
      ConfirmRestore: "Êtes-vous sûr de vouloir restaurer ce rapport journalier?",
      DailyReportDeleted: "Les rapports journaliers ont été correctement supprimés",
      ContractNumber: "# contrat",
      Vendor: "Fournisseur",
      DrillCode: "Code de foreuse",
      DeleteHeader: "Retirer",
      RemoveFromBatch: "Retirer du lot",
      MapToContract: "Assigner au contrat",
      Contract: "Contrat",
      Title: "Rapports journaliers sans contrat existant",
      BatchMapping: "Modifier les rapports journaliers sélectionnés",
      BatchDelete: "Supprimer les rapports journaliers sélectionnés",
      Mapping: "Assigner à un contrat",
      ReportDate: "Date",
      NoRowsSelected: "Veuillez sélectionner au moins une ligne"
    },
    EmployeeTitles : {
      Title : "Titres",
      NameFr : "Name (français)",
      NameEn : "Name (anglais)",
      AlternateNames : "Noms alternatifs (séparés par un point-virgule)",
      AddNew: "Ajouter un titre",
      Edit : "Éditer un titre",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce titre?",
      Deleted : "Le titre a été correctement supprimé"
    },
    Tasks : {
      Title: "Tâches",
      TitleWithSelectedCategory: "Tâches pour ",
      Name: "Tâche",
      NameEn: "Nom (en)",
      NameFr: "Nom (fr)",
      DescriptionEn: "Description (en)",
      DescriptionFr: "Description (fr)",
      AlternateNames: "Noms alternatifs (séparés par un point-virgule)",
      Category: "Categorie",
      AddNew: "Ajouter une tâche",
      Edit : "Éditer une tâche",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette tâche?",
      DeletedConfirmation : "La tâche a été correctement supprimée"
    },
    Categories : {
      Title: "Catégories",
      Name: "Catégorie",
      NameEn: "Nom (en)",
      NameFr: "Nom (fr)",
      AddNew: "Ajouter une catégorie",
      Edit : "Éditer une catégorie",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette catégorie?",
      DeletedConfirmation : "La catégorie a été correctement supprimée"
    },
    Shift: {
      '0': "Jour",
      '1': "Nuit"
    },
    Instruments : {
      Title: "Instruments",
      Name: "Instrument",
      DescriptionEn: "Description (en)",
      DescriptionFr: "Description (fr)",
      AlternateNames: "Noms alternatifs (séparés par un point-virgule)",
      AddNew: "Ajouter un instrument",
      Edit : "Éditer un instrument",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cet instrument?",
      DeletedConfirmation : "L'instrument a été correctement supprimé",
      IsActive: "Actif",
      ShowInactive: "Afficher les inactifs"
    },
    CoreBarrels : {
      Title: "Manchons aléseurs",
      NameEn: "Nom (en)",
      NameFr: "Nom (fr)",
      AlternateNames: "Noms alternatifs (séparés par un point-virgule)",
      AddNew: "Ajouter un manchon aléseur",
      Edit : "Éditer un manchon aléseur",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce manchon aléseur?",
      DeletedConfirmation : "Le manchon aléseur a été correctement supprimé"
    },
    DeviationTests : {
      Depth: "Profondeur",
      MaxDepth: "Max",
      Azimuth: "Azimut",
      Inclination: "Inclinaison",
      InstrumentName: "Valeur importée",
      Magnetism: "Magnétisme",
      AddNew: "Ajouter un test",
      Edit : "Éditer un test de déviation",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce test de déviation?",
      DeletedConfirmation : "Le test de déviation a été correctement supprimé",
      DepthGreaterThanMaxDepth : "La profondeur doit être inférieure à la profondeur maximale ({maxDepth})"
    },
    Cementation: {
      Title: "Cimentation",
      Name: "Cimentation",
      AddNew: "Ajouter une cimentation",
      Edit : "Éditer une cimentation",
      EditSelected: "Éditer les cimentations sélectionnées",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette cimentation?",
      DeletedConfirmation : "La cimentation a été correctement supprimée",
      Project: "Projet",
      Zone: "Zone",
      HoleName: "Trou",
      Drill: "Dernière foreuse",
      Contract: "Dernier contrat",
      DrillingStarted: "Début de forage",
      DrillingEnded: "Fin de forage",
      ChangeStatus: "Changer le statut de la cimentation",
      CementedOn: "Cimenté le",
      CementedFrom: "De",
      CementedTo: "À",
      LitersPumped: "Litres pompés",
      Filter: "Statut de cimentation",
      NoRowsSelected: "Veuillez sélectionner au moins une ligne",
      SaveError: "Erreur lors de l'enregistrement de la cimentation. Veuillez vous assurer que tous les champs obligatoires sont remplis et réessayez."
    },
    CementationType: {
      0: "Actif",
      1: "Bouché",
      2: "Cimenté"
    }
  }
}
